import { Component, OnInit } from '@angular/core';
import { LocalStorage } from 'src/app/decorators/local-storage.decorator';
import { IUserLogged } from 'src/app/models/user-adm/user-logged.interface';
// import { MedicalAccessControlService } from 'src/app/services/api/medical-access-control.service';
// import { ScriptService } from 'src/app/services/api/script.service';

@Component({
  selector: 'c-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  @LocalStorage('user') user: IUserLogged;

  constructor(
    // private medicalAccessControlServ: MedicalAccessControlService,
    // private scriptServ: ScriptService
  ) { }

  ngOnInit() {
    // this.scriptServ.fixQuestionnaireIsReleased().subscribe(res => console.log(res));
    // this.medicalAccessControlServ.getPending('32191557821').subscribe(res => console.log(res));
    // this.medicalAccessControlServ.getAccepted('32191557821').subscribe(res => console.log(res));
    // this.medicalAccessControlServ.accept('32191557821', 'Tdr4Vpz2vsObtf266zejO0h8UoD2').subscribe(res => console.log(res));
    // this.medicalAccessControlServ.reject('32191557821', 'Tdr4Vpz2vsObtf266zejO0h8UoD2').subscribe(res => console.log(res));
  }

}
